<template>
	<el-dialog :visible="dialogVisible" width="30%" :before-close="handleClose" @close="handleClose">
		<template slot="title">
			<img src="@/assets/img/tietle.png" alt="" style="min-width:100%">
			<span class="title_conter" style="">{{ config.content }}</span>
		</template>
		<el-descriptions :column="1" :colon="false">
			<el-descriptions-item content-class-name="contact" label-class-name="contact">
				<template :slot="label">
					<img src="@/assets/img/tips.png">
					管理员联系方式：
				</template>
				<i style="font-style:inherit;" v-html="`${phone1}&nbsp;&nbsp;` + `&nbsp;&nbsp;${phone2}`"></i>
			</el-descriptions-item>
			<el-descriptions-item content-class-name="blod_size">
				<template :slot="label">
					<img src="@/assets/img/decorate.png" style="margin-right:13px">
					账号名称：
				</template>
				{{ userInfo.username || '未登录' }}
			</el-descriptions-item>
			<el-descriptions-item content-class-name="blod_size">
				<template :slot="label">
					<img src="@/assets/img/decorate.png" style="margin-right:13px">
					到期日：
				</template>
				{{ userInfo.daoqi_time | formatDate }}
			</el-descriptions-item>
			<el-descriptions-item content-class-name="blod_size">
				<template :slot="label">
					<img src="@/assets/img/decorate.png" style="margin-right:13px">
					{{ userInfo.daoqistatus === 1 ? "剩余天数：" : "已经过期：" }}
				</template>
				{{ userInfo.day + '天' }}
			</el-descriptions-item>
		</el-descriptions>
	</el-dialog>
</template>

<script>
export default {
	name: 'NoTimeVue',
	props: {
		dialogVisible: {
			require: true
		}
	},
	data() {
		return {
			phone1: '029-88413302',
			phone2: '029-88404282',
			userInfo: {
				username: '',
				daoqi_time: '',
				day: '',
				daoqistatus: 0
			},
			label: '',
			config: {}
		}
	},
	created() {
		this.userInfo = this.$store.state.user.userInfo
		this.config = this.$store.state.user.config
		if (this.userInfo.daoqistatus === 0) {
			this.$store.commit('set_no_time')
		}
	},
	methods: {
		handleClose() { //关闭
			this.$emit('updata')
			this.$store.commit('set_no_time')
		}
	}
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
	min-width: 800px;
	border-radius: 10px;
	font-size: 16px;
}

/deep/ .el-dialog__header {
	padding: 0;



	.el-dialog__close {
		color: #fff;
	}

	.el-dialog__headerbtn {
		top: 7px;
		right: 26px;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		border: 1px solid #fff;
	}
}

/deep/.el-descriptions__table {
	font-size: 16px;

}

/deep/ .el-descriptions-item__label {
	align-items: center;

	img {
		margin-right: 6px;
	}
}

/deep/ .contact {
	color: #6345D5;
}

/deep/ .el-dialog__body {
	padding: 66px 126px;
}

/deep/ .blod_size {
	font-size: 18px;
	font-family: Source Han Sans SC;
	font-weight: 500;
	color: #5C5D6A;
}

.title_conter {
	position: absolute;
	top: 25%;
	left: 50%;
	transform: translateX(-50%);
	font-size: 16px;
	font-family: Source Han Sans SC;
	font-weight: 500;
	color: #FFFFFF;
}
</style>